// ********************************************************
// Date utility
// Common date and time utility
// We assume that input data is alway UTC. We return it as local.
// ********************************************************

import moment from 'moment'
import { app } from '../main'

export function getRealDate (date) {
  return moment.utc(date).local()
}

export function getSmartDate (date) {
  if (date == null) {
    return ''
  } else if (moment(Date.now()).date() === moment(date).date() &&
    moment(Date.now()).month() === moment(date).month() &&
    moment(Date.now()).year() === moment(date).year()) {
    // If today, only return Local Time
    return app.$t('Today') + ' ' + moment.utc(date).local().format('LT')
  } else {
    // else prefix with date
    return moment.utc(date).local().format('L LT') // e.g. 2018.11.14 16:19
  }
}

export function getTimeSeconds (date) {
  return moment.utc(date).local().format('LTS') // e.g. 2018.11.14 16:19:25
}

export function getDate (date) {
  return moment.utc(date).local().format('L') // e.g. 2018.11.14
}

export function getDateTime (date) {
  return date != null ? moment.utc(date).local().format('L LT') : '' // e.g. 2018.11.14 16:19
}

export function getDateTimeSeconds (date) {
  return date != null ? moment.utc(date).local().format('L LTS') : '' // e.g. 2018.11.14 16:19:25
}

export function getDateTimeYMDT (date) {
  return date != null ? moment.utc(date).local().format('YYYY-MM-DD HH:mm:ss.SSS') : '' // e.g. 2018-11-14 16:19:25.923
}

export function getDateTimeYMD (date) {
  return date != null ? moment.utc(date).local().format('YYYY-MM-DD') : '' // e.g. 2018-11-14
}
